import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import MaskedInput from 'react-text-mask';

import { changePixAttr, validatorHandlerBlur, getInfosInsureds } from '../../../actions/purchaseActions';
import ErrorMessage from '../error_message/ErrorMessage';
import ButtonStage from '../../standard/button_stage/ButtonStage';
import BoxInfos from '../../common/BoxInfos';
import { deadlineForText } from '../../../utils';

class Pix extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const field = {
      name: e.target.name,
      value: e.target.value,
    };

    this.props.changePixAttr(field);
  }

  render() {
    if (!this.props.paymentMethods.find((element) => element.slug === 'pix').available) return <div />;

    const deadline = this.props.paymentMethods.find((element) => element.slug === 'pix').deadline;
    const pixErrors = this.props.errors.pix;

    return (
      <div
        className="area-pix"
        style={{ display: this.props.stepDisplayPix !== 1 && this.props.mobile ? 'none' : 'block' }}
      >
        <h4 className="title" style={this.props.purchaseSummary.total === 0 ? { paddingTop: 0 } : {}}>
          Responsável pelo pagamento
        </h4>

        {this.props.purchaseSummary.total !== 0 && (
          <BoxInfos image="/assets/images/icons/warning.svg" altIcon="icon-warning" theme="warning">
            {`Lembrando que seu pagamento deverá ser realizado em até ${deadlineForText(
              deadline
            )} após finalizar a compra.`}
          </BoxInfos>
        )}

        <form className="flex">
          <div className="input-form1">
            <input
              type="text"
              id="pix_name"
              name="name"
              value={this.props.pix.name}
              placeholder="Nome completo"
              onChange={this.handleChange}
              className={`${pixErrors.name ? 'with-error' : ''}`}
              onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'pix_name')}
            />
            <ErrorMessage anchor="pix_name" field1="pix" field2="name" />
          </div>
          <div className="input-form1">
            <MaskedInput
              name="cpf"
              guide
              type="tel"
              placeholder="CPF"
              onChange={this.handleChange}
              value={this.props.pix.cpf}
              className={`${pixErrors.cpf ? 'with-error' : ''}`}
              mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
              onBlur={(e) => this.props.validatorHandlerBlur(e.target.value, 'pix_cpf')}
            />
            <ErrorMessage anchor="pix_cpf" field1="pix" field2="cpf" />
          </div>
        </form>
        <button className="transfer-infos payment" onClick={() => this.props.getInfosInsureds(4)}>
          Copiar dados do primeiro segurado
        </button>
        {this.props.mobile && (
          <React.Fragment>
            <ButtonStage data-cy="step-payment-data" index={3} stage="INSURED_PAYMENT_PURCHASE" />
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      pix: state.purchase.pix,
      paymentMethods: state.purchase.paymentMethods,
      mobile: state.mobile.mobileActive,
      stepDisplayPix: state.purchase.stepDisplayPix,
      errors: state.purchase.errors,
      purchaseSummary: state.purchase.purchaseSummary,
    }),
    { changePixAttr, validatorHandlerBlur, getInfosInsureds }
  )(Pix)
);



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/Pix.jsx